/**
 * 新建/编辑规则
 */
import React, { useState, useEffect, memo } from 'react';
import PropTypes from 'prop-types';
import styles from './RuleModal.module.scss';
import http from '@/assets/api/http';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { FloatConversion } from '@/util/conversion';
import { connect } from 'react-redux';
import model from '@/reducers/system/operatingrule/model';
import {
    Modal,
    message,
    Form,
    Input,
    Radio,
    Space,
    InputNumber,
    Button,
} from 'antd';

const FormItem = Form.Item;
const RadioGroup = Radio.Group;

const layout = {
    labelCol: {
        span: 4,
        offset: 2
    },
    wrapperCol: {
        span: 19,
    },
};

const TempModal = ({
    closeMode,
    data,
    cancelPre,
    getCancelRulePre,
    getCleanCancelRulePre,
    ...restProps
}) => {

    const [title, setTitle] = useState(restProps.title);
    const [visible, setVisible] = useState(restProps.visible);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [form] = Form.useForm();
    const floatConversion = new FloatConversion();
    const [receivingVal, setReceivingVal] = useState(0);//已接单时长-左(最小值限制)
    const initList = ([{ startDistance: null, endDistance: null, cost: null }]);//默认-距离范围数据

    useEffect(() => {
        //新建获取上一条取消规则
        if (Object.keys(data).length === 0) getCancelRulePre();
        return () => {
            getCleanCancelRulePre();
        };
    }, []);

    useEffect(() => {
        const { startLength, startDistance } = cancelPre;
        if (Object.keys(cancelPre).length !== 0) {
            form.resetFields();
            setReceivingVal(startLength + 1);
            form.setFieldsValue({
                userinfo: [{ startDistance: startDistance, endDistance: null, cost: null }]
            });
        }
    }, [cancelPre]);


    const _handleOk = () => {
        form.validateFields().then((values) => {
            const { scenario, receivingL, receivingR, userinfo } = values;
            //数据层级判断 公里范围成'Z'型限制，金额层级增大与金额换算
            for (let i = 0; i < userinfo.length; i++) {
                if (userinfo[i].startDistance >= userinfo[i].endDistance) {//同层
                    return message.warning(`第${i + 1}层距离范围(公里)不符合`);
                }
                if (i < userinfo.length - 1) {//连续跨层
                    if (userinfo[i].endDistance > userinfo[i + 1].startDistance) {
                        return message.warning(`上下层距离范围(公里)不符合`);
                    }
                    if (userinfo[i].cancelCost > userinfo[i + 1].cancelCost) {
                        return message.warning(`费用(元)不符合`);
                    }
                }
            }
            let userinfoList = userinfo.map(v => {
                v.cancelCost = floatConversion.multiply(v.cost, 100);
                let { cost, ...resetSatae } = v;
                return resetSatae;
            });

            let submitUrl = Object.keys(data).length === 0 ? 'addRules' : 'updateRules';
            let submitData = {
                id: Object.keys(data).length === 0 ? undefined : data.id,
                stateType: scenario,
                startLength: receivingL,
                endLength: receivingR,
                rules: userinfoList
            }
            setConfirmLoading(true);
            http(`/?cmd=com.xqxc.api.pig.mis.biz.rules.RiderCancelRuleMisService.${submitUrl}`, submitData, 'POST').then(() => {
                message.success('提交成功');
                setVisible(false);
                closeMode(true);
            }).catch((e = {}) => {
                message.error(e.message || '提交异常');
                setConfirmLoading(false);
            });
        }).catch((info) => { });
    };

    const _handleCancel = () => {
        setVisible(false);
        closeMode();
        if (Object.keys(data).length === 0) {
            form.setFieldsValue({
                userinfo: initList
            });
        }
    };

    //已接单时长-左
    const receivingLHandle = (value) => {
        form.setFieldsValue({ receivingR: null })
        setReceivingVal(value + 1);
    };

    //已接单时长-右
    const receivingRHandle = (rule, value, callback) => {
        const { getFieldValue } = form;
        if (!value) {
            return Promise.reject('请输入');
        } else {
            if (Number(value) <= Number(getFieldValue('receivingL'))) {
                return Promise.reject('请输入已接单时长区间');
            } else {
                return Promise.resolve();
            }
        }
    }

    //编辑时-处理距离范围数据-金额换算
    const userinfoHandle = (list) => {
        return list.map(v => {
            v.cost = floatConversion.divide(v.cancelCost, 100);
            return v;
        });
    };


    return (
        <Modal
            width={720}
            centered
            title={title}
            visible={visible}
            confirmLoading={confirmLoading}
            onOk={_handleOk}
            onCancel={_handleCancel}
            destroyOnClose={true}
            keyboard={true}
            maskClosable={false}
            cancelText='取消'
            okText='确认'
        >

            <Form
                // {...layout}
                className={styles.container}
                autoComplete='off'
                name="create"
                scrollToFirstError
                form={form}
                initialValues={{
                    scenario: 'RIDER_TAKED_NO_PICK',
                    receivingL: Object.keys(data).length === 0 ? cancelPre.startLength : data.startLength,
                    receivingR: data.endLength,
                    userinfo: Object.keys(data).length === 0 ? initList : userinfoHandle(data.rules),
                }}
            >
                <FormItem
                    style={{ marginLeft: 81 }}
                    name="scenario"
                    label="场景"
                    colon={false}
                    rules={[{ required: true, }]}
                >
                    <RadioGroup>
                        <Radio value={'RIDER_TAKED_NO_PICK'}>骑士已接单未取件</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem className={`${styles.flexCurt}`}>
                    <span className={styles.curt}>已接单时长</span>
                    <FormItem
                        name="receivingL"
                        colon={false}
                        rules={[{ required: true, message: '请输入' }]}>
                        <InputNumber
                            onChange={receivingLHandle}
                            disabled={(Object.keys(data).length === 0 && Object.keys(cancelPre).length !== 0) ? true : false}
                            style={{ width: '150px', marginRight: '8px' }}
                            min={1}
                            max={9999}
                            keyboard={true}
                            placeholder='请输入'
                            precision={0}
                        />
                    </FormItem>
                    <span className={styles.curt}>分钟至</span>
                    <FormItem
                        name="receivingR"
                        colon={false}
                        rules={[{ required: true, type: 'number', validator: receivingRHandle }]}>
                        <InputNumber
                            style={{ width: '150px', marginRight: '8px' }}
                            min={receivingVal}
                            max={10000}
                            keyboard={true}
                            placeholder='请输入'
                            precision={0}
                        />
                    </FormItem>
                    <span className={styles.curt}>分钟</span>
                </FormItem>
                <Form.List
                    name="userinfo"
                >
                    {(fields, { add, remove }) => {
                        return <>
                            {fields.map(field => (
                                <Space key={field.key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                                    <span className={styles.curt}>距离范围</span>
                                    <FormItem
                                        {...field}
                                        name={[field.name, 'startDistance']}
                                        fieldKey={[field.fieldKey, 'startDistance']}
                                        colon={false}
                                        rules={[{ required: true, message: '请输入', type: 'number' }]}>
                                        <InputNumber
                                            style={{ width: '100px', marginRight: '8px' }}
                                            disabled={(Object.keys(data).length === 0 && Object.keys(cancelPre).length !== 0 && field.name === 0) ? true : false}
                                            min={0}
                                            max={10000}
                                            keyboard={true}
                                            placeholder='请输入'
                                            precision={0}
                                        />
                                    </FormItem>
                                    <span className={styles.curt}>公里至</span>
                                    <FormItem
                                        {...field}
                                        name={[field.name, 'endDistance']}
                                        fieldKey={[field.fieldKey, 'endDistance']}
                                        rules={[{ required: true, message: '请输入', type: 'number' }]}>
                                        <InputNumber
                                            style={{ width: '100px', marginRight: '8px' }}
                                            min={0}
                                            max={10000}
                                            keyboard={true}
                                            placeholder='请输入'
                                            precision={0}
                                        />
                                    </FormItem>
                                    <span className={styles.curt}>公里<i style={{ display: 'inline-block', width: 15 }}></i>取消费用</span>
                                    <FormItem
                                        {...field}
                                        name={[field.name, 'cost']}
                                        fieldKey={[field.fieldKey, 'cost']}
                                        rules={[{ required: true, message: '请输入', type: 'number' }]}>
                                        <InputNumber
                                            style={{ width: '100px', marginRight: '8px' }}
                                            min={0}
                                            max={100}
                                            keyboard={true}
                                            placeholder='请输入'
                                            precision={1}
                                        />
                                    </FormItem>
                                    <span className={styles.curt}>元</span>
                                    {field.name !== 0 && <MinusCircleOutlined onClick={() => remove(field.name)} />}
                                </Space>
                            ))}
                            <FormItem>
                                <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />} />
                            </FormItem>
                        </>;
                    }}
                </Form.List>
            </Form>
        </Modal>
    );

}

TempModal.propTypes = {
    data: PropTypes.object, // 弹框入参
    visible: PropTypes.bool.isRequired, // 是否显示弹框
    closeMode: PropTypes.func.isRequired, // 关闭弹框的回调函数
    title: PropTypes.string,// 弹框标题
    cancelPre: PropTypes.object,//获取上一条取消规则
    getCancelRulePre: PropTypes.func,//获取上一条取消规则(action)
    getCleanCancelRulePre: PropTypes.func,//清除
};

const mapStateToProps = (state) => {
    return {
        cancelPre: state.operatingrule.cancelPre,
    };
};

export default connect(mapStateToProps, model.actions)(memo(TempModal));